export const celebApi = process.env.NEXT_PUBLIC_BASE_CELEB_API_URL;
export const googleApi = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;
export const domain = "https://celebstory.com/";
